import React from 'react'

import classes from './statisticCard.module.css'

const StatisticCard = ({ name, value, style }) => {
    return (
        <div className={classes.statisticCard} style={style}>
            <p className={classes.name}>{name}</p>
            <p className={classes.value}>{value}</p>
        </div>
    )
}

export default StatisticCard
